var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalonSocialWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salon_2_WHite",
    "data-name": "Salon 2_WHite",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220.009,
    viewBox: "0 0 220 220.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M220.011,41.9a9.676,9.676,0,0,0-9.665-9.672H168.014V18.781A9.672,9.672,0,0,0,164.789,0H55.214a9.672,9.672,0,0,0-3.219,18.788V32.227H9.661A9.672,9.672,0,0,0,6.435,51.009V197.458a3.225,3.225,0,0,0,3.225,3.214H71.325L53.281,214.208a3.225,3.225,0,0,0,1.931,5.8H164.786a3.225,3.225,0,0,0,1.937-5.8l-18.042-13.536h61.665a3.225,3.225,0,0,0,3.214-3.214h0V51.007A9.672,9.672,0,0,0,220.011,41.9Zm-51.991,9.665h39.1V161.137H168.014ZM55.214,6.444H164.789a3.225,3.225,0,1,1,0,6.444H68.1a3.225,3.225,0,0,0,0,6.444h93.479V194.224h-6.46V125.691a3.225,3.225,0,0,0-3.225-3.236H68.1a3.225,3.225,0,0,0-3.219,3.225v68.577H58.435V16.1a3.225,3.225,0,0,0-3.225-3.225h0a3.225,3.225,0,0,1,0-6.444Zm58.013,187.813V154.691H135.78v39.535Zm-29.006,0V154.691h22.56v39.535Zm54.787-45.98H81a3.225,3.225,0,0,0-3.225,3.225h0v42.754H71.33V128.91h77.352v65.316h-6.449V151.472a3.225,3.225,0,0,0-3.225-3.225ZM51.993,51.562V161.137h-39.1V51.562ZM9.661,38.672H51.993v6.444H9.661a3.225,3.225,0,1,1,0-6.444Zm3.228,128.91h39.1v26.647h-39.1Zm142.229,45.982H64.883l17.19-12.891h55.861Zm12.891-19.335V167.581h39.1v26.647ZM210.346,45.116H168.007V38.672h42.339a3.225,3.225,0,0,1,0,6.444Z",
    transform: "translate(-0.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M35.647,142.43H55.423a3.225,3.225,0,0,0,3.225-3.225V100.515a3.225,3.225,0,0,0-3.225-3.225H35.647a3.225,3.225,0,0,0-3.219,3.225h0v38.672a3.225,3.225,0,0,0,3.219,3.243Zm3.225-38.672H52.191v32.225H38.877Z",
    transform: "translate(-13.105 -39.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M315.591,97.29H295.819a3.225,3.225,0,0,0-3.219,3.225h0v38.672a3.225,3.225,0,0,0,3.219,3.243h19.772a3.225,3.225,0,0,0,3.219-3.225V100.515a3.225,3.225,0,0,0-3.219-3.225Zm-3.225,38.678H299.046v-32.2h13.319Z",
    transform: "translate(-118.151 -39.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M35.647,228.9H55.423a3.225,3.225,0,0,0,3.225-3.219V187a3.225,3.225,0,0,0-3.225-3.219H35.647A3.219,3.219,0,0,0,32.428,187v38.678A3.219,3.219,0,0,0,35.647,228.9Zm3.225-38.672H52.191v32.2H38.877Z",
    transform: "translate(-13.105 -74.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M315.591,183.78H295.819A3.219,3.219,0,0,0,292.6,187v38.678a3.219,3.219,0,0,0,3.219,3.219h19.772a3.219,3.219,0,0,0,3.219-3.219V187A3.219,3.219,0,0,0,315.591,183.78Zm-3.225,38.672H299.046v-32.2h13.319Z",
    transform: "translate(-118.151 -74.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M144.151,74.48H124.379a3.225,3.225,0,0,0-3.219,3.225h0v38.672a3.225,3.225,0,0,0,3.219,3.225h19.772a3.225,3.225,0,0,0,3.219-3.225V77.705A3.225,3.225,0,0,0,144.151,74.48Zm-3.223,38.678h-13.3v-32.2h13.319Z",
    transform: "translate(-48.93 -30.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M228.447,75.93H208.705a3.225,3.225,0,0,0-3.225,3.214h0V117.82a3.225,3.225,0,0,0,3.225,3.225h19.741a3.225,3.225,0,0,0,3.219-3.225V79.144A3.219,3.219,0,0,0,228.447,75.93ZM225.221,114.6h-13.3V82.4h13.319Z",
    transform: "translate(-82.976 -30.659)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSocialWhite);
export default __webpack_public_path__ + "static/media/SalonSocial_White.f52cea5f1bb931ed629c8442d5a1a544.svg";
export { ForwardRef as ReactComponent };